import React, { useState, useEffect, useContext, createContext } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';
import { numberFormatter } from '../../../components/formatters/numberFormatter';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button } from 'antd';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';

export const selectedMissionContext = createContext();

function MultiPriceModal(props) {

  const { api, showModal, toggleModal, title, addProductToCart, selectedTab, idRow, selectedProduct, data } = props;
  const { tabData, setTabData } = useContext(PosCartContext);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const { settingData } = useContext(DataContext);


  const cart = tabData[selectedTab].cart;


  useEffect(() => {
    setInputValue("");
  }, [showModal]);


  const selectPrice = (price) => {

    const newProduct = {...selectedProduct};
    newProduct.price = price;
    newProduct.netPrice = price;
    newProduct.itemPrice = price;
    newProduct.totalPrice = price;
    newProduct.prices = [];
    addProductToCart(newProduct, 1);
    toggleModal();
  }

  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static' className='Delete_modal'>
      <Modal.Header style={{ background: "#1d7790" }} closeButton>
        <Modal.Title className="arabicText" style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="arabicText">

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)', 
            gap: '16px', 
            textAlign: 'center',
            userSelect: 'none',
          }}
        >
          {selectedProduct?.prices?.map((priceItem, index) => (
            <div
              key={index}
              className="card"
              style={{
                height: '15vh',
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'center', 
                alignItems: 'center', 
                backgroundColor: '#a4c436',
                cursor: 'pointer',
              }}
              onClick={() => selectPrice(priceItem.price)}
            >
              <h6>{priceItem.name}</h6>
              <h3>{numberFormatter(priceItem.price)}</h3>
            </div>
          ))}
        </div>


      </Modal.Body>
    </Modal>
  );
}

export default MultiPriceModal;
